import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-255f6112"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "recycle" }
const _hoisted_2 = {
  key: 0,
  class: "form-view pc-wrap"
}
const _hoisted_3 = { class: "table-top pt10 pb10" }
const _hoisted_4 = { class: "flex-a-center" }
const _hoisted_5 = { class: "table-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "还原", -1))
const _hoisted_8 = {
  key: 0,
  class: "flex-c-center pt20 pb20"
}
const _hoisted_9 = {
  key: 1,
  class: "phone-wrap flex-column-center"
}
const _hoisted_10 = { class: "list-wrap" }
const _hoisted_11 = {
  key: 0,
  class: "flex-c-center pt20 pb20"
}

import { ref, defineAsyncComponent, onMounted } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { Delete, RefreshLeft } from "@element-plus/icons-vue";
import { fileRecycleApi, fileRecycleDelApi, fileRecycleRestoreApi } from '@/api/file'
import checkPc from '@/utils/checkPc'

/**
 * 判断是否PC端
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isPC = checkPc()

// 引入组件
const MainTitle = defineAsyncComponent(() => import("@/views/member/components/MainTitle.vue"));
const PhoneListItem = defineAsyncComponent(() => import("@/views/member/recycle/PhoneListItem.vue"));

/**
 * 筛选表单
 */
const form = ref<any>({
  title: ''
})

/**
 * 文件列表处理
 */
const tableData = ref<any>([])
const tableParams = ref({ limit: 15, page: 1, title: '' })
const tableTotal = ref(0)
// 获取文件列表
const getFileList = async () => {
  const res: any = await fileRecycleApi(tableParams.value)
  // console.log(res)
  tableData.value = res.data
  tableTotal.value = res.total
}

/* 表格数据多选处理 */
const multipleTableRef = ref()
const multipleSelection = ref([])
const handleSelectionChange = (val: any) => {
  multipleSelection.value = val
}

//  提示文字处理
const toTips = (type: string) => {
  let tips = '', api = <any>null
  switch (type) {
    case 'del':
      tips = '删除'
      api = fileRecycleDelApi
      break;
    case 'restore':
      tips = '恢复'
      api = fileRecycleRestoreApi
      break;
  }
  return { tips, api }
}

// 批量删除、恢复
const delBtn = (type: string) => {
  let data = multipleSelection.value
  let tips = toTips(type).tips
  if (data.length == 0) {
    ElMessage.error(`请选择需要${tips}的数据`)
  } else {
    let ids = data.map((item: any) => item.id)
    // console.log(ids)
    toDelete(type, ids.toString())
  }
}

// 删除接口
const toDelete = async (type: string, ids: any, showConfirm: Boolean = true) => {
  let { tips, api } = toTips(type)
  try {
    if (showConfirm) {
      await ElMessageBox.confirm(`该操作会${tips}当前数据`, `确定要${tips}数据吗?`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
    }
    await api({ id: ids })
    ElMessage.success(`${tips}成功`)
    getFileList()
  } catch (error) {

  }
}

// 手机端删除、恢复
const toDeleteM = (e: any) => {
  toDelete(e.type, e.id, false)
}

/**
 * 用户下拉
 */
const userOptions = ref<any[]>([]);

onMounted(() => {
  getFileList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isPC))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(MainTitle), null, {
            default: _withCtx(() => [
              _createTextVNode("回收站")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form, {
              inline: "",
              model: form.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      color: "#717171",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (delBtn('del')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("批量删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      color: "#FF7B6D",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (delBtn('restore')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("批量恢复")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_input, {
                        modelValue: tableParams.value.title,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tableParams.value.title) = $event)),
                        placeholder: "请输入文件标题"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_button, {
                        color: "#FF7B6D",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {tableParams.value.page = 1; getFileList()})
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("搜索")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_table, {
              ref_key: "multipleTableRef",
              ref: multipleTableRef,
              data: tableData.value,
              style: {"width":"100%"},
              height: "calc(100vh - 0.84rem - 200px)",
              size: "default",
              onSelectionChange: handleSelectionChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: 55
                }),
                _createVNode(_component_el_table_column, {
                  prop: "title",
                  label: "文档名称",
                  align: "center",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "id",
                  label: "文档ID",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "deletetime",
                  label: "删除时间",
                  width: 200,
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "recycle_text",
                  label: "失效时间",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "action",
                  label: "操作",
                  align: "center",
                  width: 200
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      link: "",
                      icon: _unref(Delete),
                      onClick: ($event: any) => (toDelete('del', scope.row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["icon", "onClick"]),
                    _createVNode(_component_el_button, {
                      link: "",
                      icon: _unref(RefreshLeft),
                      onClick: ($event: any) => (toDelete('restore', scope.row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["icon", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            (tableTotal.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_el_pagination, {
                    background: "",
                    layout: "total, prev, pager, next, jumper",
                    "current-page": tableParams.value.page,
                    "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((tableParams.value.page) = $event)),
                    "page-size": tableParams.value.limit,
                    "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((tableParams.value.limit) = $event)),
                    total: tableTotal.value,
                    onCurrentChange: getFileList
                  }, null, 8, ["current-page", "page-size", "total"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item) => {
              return (_openBlock(), _createBlock(_unref(PhoneListItem), {
                key: item.file_id,
                data: item,
                onToDelete: toDeleteM
              }, null, 8, ["data"]))
            }), 128))
          ]),
          (tableTotal.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_el_pagination, {
                  "hide-on-single-page": true,
                  background: "",
                  layout: "prev, next",
                  "current-page": tableParams.value.page,
                  "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((tableParams.value.page) = $event)),
                  "page-size": tableParams.value.limit,
                  "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((tableParams.value.limit) = $event)),
                  total: tableTotal.value,
                  onCurrentChange: getFileList
                }, null, 8, ["current-page", "page-size", "total"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})